// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3p_7k","label":"styles_label__1-Rme"};